import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';

const faqs = [
  {
    q: 'Czy muszę instalować jakieś oprogramowanie?',
    a: 'Nie. RzutNieruchomości.pl to aplikacja działająca całkowicie w przeglądarce internetowej. Nie wymaga instalacji żadnego dodatkowego oprogramowania. Korzystać z niej możesz na komputerze z systemem Windows, macOS lub Linux. Dla najlepszej wydajności zalecamy przeglądarkę Google Chrome.'
  },
  {
    q: 'Czy po zakupie otrzymam przyszłe aktualizacje?',
    a: 'Tak. RzutNieruchomości.pl jest stale rozwijanym narzędziem online. Nie musisz pobierać ani instalować nowych wersji programu – wszystkie aktualizacje, poprawki oraz nowe funkcje są udostępniane automatycznie i będą dostępne w ramach aktywnego planu.'
  },
  {
    q: 'Czy poradzę sobie z wykonaniem rzutu nieruchomości?',
    a: 'Oczywiście. Kreator został zaprojektowany zarówno dla profesjonalistów, jak i osób, które nigdy wcześniej nie tworzyły rzutów. Intuicyjny interfejs oraz gotowe narzędzia pozwalają szybko przygotować estetyczny i czytelny rzut mieszkania, domu lub lokalu. Dodatkowo udostępniamy instrukcje i materiały pomocnicze, które ułatwią rozpoczęcie pracy.'
  },
  {
    q: 'Czy muszę podawać numer karty płatniczej?',
    a: 'Nie. W przypadku planu Pro Jednorazowy nie są wymagane cykliczne płatności ani zapisywanie karty. Możesz wygodnie zapłacić m.in. BLIK-iem, szybkim przelewem lub kartą, a dostęp zostanie aktywowany natychmiast po zaksięgowaniu płatności.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="py-32 bg-gray-50/30 border-t border-gray-100">
      <div className="max-w-3xl mx-auto px-6">
        
        <div className="text-center mb-20">
          <h2 className="text-3xl sm:text-[40px] text-[#1F2937] tracking-tight mb-4">Najczęściej zadawane pytania</h2>
          <p className="text-lg text-gray-500 font-normal">
            Poniżej znajdują się pytania i odpowiedzi, które są nam najczęściej zadawane. <br className="hidden sm:block" />
            Szukasz szczegółowego poradnika? Sprawdź w dziale <a href="#" className="text-gray-900 underline underline-offset-4">Pomoc</a>.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white border border-gray-200/60 rounded-xl overflow-hidden shadow-sm">
              <button 
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50/50 transition-colors"
              >
                <span className="text-[16px] font-semibold text-[#1F2937] pr-8">{faq.q}</span>
                <div className="shrink-0 w-8 h-8 rounded-full border border-gray-100 flex items-center justify-center bg-gray-50">
                  <SafeIcon icon={openIndex === i ? FiMinus : FiPlus} className="w-4 h-4 text-gray-500" />
                </div>
              </button>
              
              <AnimatePresence>
                {openIndex === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <div className="px-6 pb-6 text-[15px] text-gray-500 leading-relaxed font-normal">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}